export default __webpack_public_path__ + "static/media/cpp.0a81196c.png";